import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('foundations-theming', {
  library: 'foundations-theming'
});